defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/PlayersTab',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/Modals/RemovePlayerModal',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/Modals/MakeChairmanModal'
  ],
  function (m, Ensighten, Avatar, CtaButton, PostCard, CardContent, RemovePlayerModal, MakeChairmanModal) {
    const PlayersTab = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.playersTabDictionary = controller.rootDictionary.get.bind({ prefix: 'ClubSettings/PlayersTab/' });
        this.playerItemDictionary = controller.rootDictionary.get.bind({ prefix: 'ClubSettings/PlayersTab/PlayerItem/' });

        this.players = this.clubModelFields().clubPlayers;
        this.chairmanId = this.clubModelFields().chairman().playerId;

        this.showRemovePlayerModal = (player) => {
          return () => {
            Ensighten.pushGaEvent('spil_sammen', 'cta_click', 'slet spiller?');
            this.modal.setContent(m(RemovePlayerModal, {
              controller: this,
              player,
              template: this.modal.defaultContentTemplate
            }));
            this.modal.show();
          };
        };

        this.showMakeChairmanModal = (player) => {
          return () => {
            Ensighten.pushGaEvent('spil_sammen', 'cta_click', 'gør til formand?');
            this.modal.setContent(m(MakeChairmanModal, {
              controller: this,
              player,
              template: this.modal.defaultContentTemplate
            }));
            this.modal.show();
          };
        };
      },

      view: function (controller, ignoreArgs, $slots) {
        const content = () => {
          return [
            m('.play-together-club-settings__players',
              controller.players().map((player) => {
                const isChairman = player.playerId === controller.chairmanId;
                const currentUserIsSelf = player.playerId === controller.currentUserId();
                const playsParticipatingCount = player.playsParticipatingCount;

                const showMakeChairmanButton = controller.isCurrentUserChairman() && !isChairman;
                const showDeleteUserButton = () => {
                  if (playsParticipatingCount === 0) {
                    return controller.isCurrentUserChairman() || currentUserIsSelf;
                  }
                  return false;
                };

                const playsParticipatingText = () => {
                  if (!playsParticipatingCount) {
                    return controller.playerItemDictionary('PlaysParticipatingZero');
                  }
                  if (playsParticipatingCount === 1) {
                    return controller.playerItemDictionary('PlaysParticipatingSingle');
                  }
                  return controller.playerItemDictionary('PlaysParticipatingMultiple', { COUNT: playsParticipatingCount });
                };

                return m('.club-settings__player-row', [
                  m('.club-settings__player-column', [
                    Avatar({
                      isChairman: isChairman,
                      name: player.name
                    }),
                    m('.player-info', [
                      m('.player-name', player.name),
                      m('.player-details', playsParticipatingText())
                    ])
                  ]),
                  m('.club-settings__player-column', [
                    showMakeChairmanButton ? m('.club-settings__make-chairman-button', {
                      onclick: controller.showMakeChairmanModal(player)
                    }, m('svg.icon',
                      m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#crown' })
                    )
                    ) : null,
                    showDeleteUserButton() ? m('.club-settings__delete-button', {
                      class: !controller.isCurrentUserChairman() ? 'delete-button--with-text' : '',
                      onclick: controller.showRemovePlayerModal(player)
                    },
                    !controller.isCurrentUserChairman() ? controller.playerItemDictionary('RemoveYourselfButton') : null,
                    m('svg.icon',
                      m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#x-close' })
                    )) : null
                  ])
                ]);
              })
            ),
            controller.players().length === 1 ? PostCard({
              icon: 'spilSammen_logo_icon',
              title: controller.playersTabDictionary('InvitePlayerCard/Title'),
              description: controller.playersTabDictionary('InvitePlayerCard/Description')
            }) : null
          ];
        };

        const footer = () => {
          const allowAllInvite = controller.clubModelFields().rules.allowAllInvite();
          const isClubLocked = !controller.clubModelFields().rules.isOpenForRegistration();
          return [
            CtaButton({
              text: controller.playersTabDictionary('InviteToClubButton'),
              href: controller.navigationPaths.showInvitePage + '?klubId=' + controller.clubId(),
              disabled: !allowAllInvite && !controller.isCurrentUserChairman(),
              options: ['primary']
            }),
            isClubLocked ? PostCard({
              icon: 'lock',
              type: 'transparent',
              title: controller.playersTabDictionary('ClosedForInviteCard/Title'),
              description: controller.playersTabDictionary('ClosedForInviteCard/Description')
            }) : null
          ];
        };

        return CardContent({
          title: controller.playersTabDictionary('Title'),
          $header: $slots.header,
          $content: content(),
          $footer: footer()
        });
      }
    };

    return PlayersTab;
  });
